import React, { useCallback } from "react";

interface ClickableProps {
    children: React.ReactNode;
    onClick: (event: React.MouseEvent) => void;
    clickable?: boolean;
}

const Clickable: React.FC<ClickableProps> = ({ children, onClick, clickable = true}) => {
    const handleClick = useCallback(
        (event: React.MouseEvent) => {
            onClick(event);
        },
        [onClick]
    );

    return (
        <div onClick={clickable ? handleClick : ()=>{}} style={{ display: "contents", cursor: clickable ? "pointer" : ""}}>
            {children}
        </div>
    );
};

export default Clickable;